<template>
  <div id="app">
    <el-container>
      <!-- 头部导航栏 -->
      <el-header>
        <el-menu @click.native="logotap">
          <img
            src="@/assets/images/zaoyinggroup_logo.png"
            alt
            srcset
            class="zaoyinggroup_logo"
            draggable="false"
          />
        </el-menu>
        <el-menu class="header_title">
          <div v-for="(item, index) in headerMenu" :key="index">
            <router-link :to="item.url" class="menutitle">
              <el-menu-item :class="seletedindex == item.id ? 'active' : ''">{{
                item.title
              }}</el-menu-item>
            </router-link>
          </div>
        </el-menu>
      </el-header>
    </el-container>
  </div>
</template>

<script>
export default {
  props: {
    seletedindex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      headerMenu: [
        {
          id: 0,
          title: "首页",
          url: "/",
        },
        {
          id: 1,
          title: "关于我们",
          url: "/aboutUs",
        },
        // {
        //   id: 2,
        //   title: "教育服务",
        //   url: "/"
        // },
        // {
        //   id: 3,
        //   title: "课程体系",
        //   url: "/course",
        // },
        {
          id: 7,
          title: "业务板块",
          url: "/business",
        },
        {
          id: 4,
          title: "新闻动态",
          url: "/newsInformation",
        },
        {
          id: 6,
          title: "人才招聘",
          url: "/recruitment",
        },
        {
          id: 5,
          title: "联系我们",
          url: "/contactUs",
        },
      ],
    };
  },
  methods: {
    logotap() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 40px;
  padding: 10px 0px;
}

.el-menu {
  border: none;
  cursor: pointer;
}
.el-header {
  width: 100%;
  color: #000000;
  display: flex;
  justify-content: space-around;
}
.zaoyinggroup_logo {
  width: 200px;
}
.header_title {
  display: flex;
}
.el-menu-item {
  font-size: 16px;
}
.active {
  font-weight: bold;
  color: #40a9ff !important;
}
.menutitle {
  text-decoration: none;
  color: #000;
}
</style>